export const meta = {
  title: '可接受使用政策 | CADCraft AI',
  description:
    '使用 cadcraft.org、其 CADCraft 指南以及托管的 CADCraft 在线版时需遵守的规则。',
  updated_at: '2026-10-20',
};

## 适用范围

本政策适用于所有使用 cadcraft.org（“本站”，由 CADCraft AI 运营）的用户。本站提供 CADCraft 下载与安装指南、CADCraft 与 Autodesk AutoCAD 的对比、教程以及托管的 CADCraft 网页版。使用本站即表示你同意遵守本规则以及我们的[服务条款](/terms-of-service)。

## 你可以

- 阅读、分享和链接我们的指南、教程与对比内容。
- 使用托管的 CADCraft 网页版创建、打开、编辑、保存和导出你自己的图纸。
- 通过我们提供的官方 GitHub Releases 链接下载 CADCraft，并按其 MIT 或 Apache-2.0 协议使用。
- 引用本站内容的少量片段，并附上原页面链接。

## 你不可以

- **攻击或过载本站。** 禁止拒绝服务攻击、未经许可的漏洞扫描，以及影响他人使用的自动化流量。
- **大规模抓取。** 不得整站复制，或以损害本站运行、误导访客来源的方式进行镜像。
- **冒充官方。** 不得将 cadcraft.org 宣称为 Autodesk 或 ArtCraft 的官方网站，也不得声称本站内容获得上述公司背书。
- **分发篡改过的软件。** 不得利用本站的链接、截图或说明，把修改过或含恶意代码的版本冒充为官方 CADCraft 版本。
- **违反法律。** 不得利用本站或托管应用侵犯版权或商标，或处理你无权使用的图纸。
- **滥用支持渠道。** 不得向 support@cadcraft.org 或任何联系表单发送垃圾信息、骚扰或钓鱼内容。

## 你的图纸

使用免费版时，你在托管的 CADCraft 应用中处理的图纸只保存在你的浏览器中，不会上传到我们的服务器；开通 CADCraft 在线版 Pro 后，图纸还会保存到你账户下的私有云存储，详见隐私政策。你需自行负责文件内容并做好备份。

## 问题反馈

如发现安全问题、失效或可疑的下载链接、不准确的信息或对本站的滥用，请发送邮件至 [support@cadcraft.org](mailto:support@cadcraft.org)，并附上页面链接和简要说明。

## 执行

对于违反本政策的行为，我们可能会屏蔽流量、限制访问或删除相关内容；为保护本站和访客，必要时可不另行通知。

## 变更

我们可能会更新本政策，页面顶部的日期为最新版本日期。
